<div class="main">
    <!-- <div style="z-index : 10;position: absolute;" class="col-12">
        <img src='assets/images/carouselbg.png' alt="login" class="login" height="635" style="width: inherit;filter: blur(16px);
  -webkit-filter: blur(16px);" width="1340">
    </div> -->
    <div class="imageContainer">
        <img src="assets/images/registrationSuccess.png" alt="Registration Success" width="200px">
        <!-- <img src="../../../images/registrationSuccess.png" alt="Registration Success"> -->
    </div>

    <div class="regText">Registration Successful!</div>

    <div style="text-align: center; margin-top:10px; font-size:16px">
        We have shared username and password with you over registered email.
    </div>

    <button type="button" (click)="getStartedClick()">GET STARTED</button>
</div>